import React from "react";

export const ColorModeContext = React.createContext({});

export const WidthContext = React.createContext({});

export const ToggleContext = React.createContext({});
